// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1gy03","info":"UpdateTermsInfo_info__1kXG_"};